import { useGlobalState } from "../../providers/globalState/GlobalStateProvider";
import { useStaticText } from "../../providers/staticText/staticTextProvider";
import ProgressBar from "./progressBar";

function Header() {
  const { showLogo, currentTitle, showProgressBar, progressBarValue, currentStep } = useGlobalState()
  const { name } = useGlobalState()
  const { getStaticText } = useStaticText()

  return (
    <header>
      {showProgressBar ? (<ProgressBar progress={progressBarValue} />) : ""}
      {showLogo ? (
        <div className='top'>
          <img className='logo-img' src="https://cdn-eu.lolaenglish.com/web-images%2Flola.png" alt="" />
          <p>Lola Speak</p>
        </div>
      ) : ""}
      {currentTitle && (
        <h1 className={currentStep === "choosePlan" ? 'header-choose-plan' : ""}>
          {currentTitle}
        </h1>
      )}
    </header>
  );
}


export default Header;